import checkout from "./form";

const {
  formField: {
    fullName,
    chiefAccountant,
    accountingServices,
    signer,
    certificate,
    timeSign,

    taxpayersName,
    taxpayersId,

    unit,
    bctc,
    htldl,
    auditOpinion,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [certificate.name]: "",
  [timeSign.name]: "",
  [chiefAccountant.name]: "",
  [accountingServices.name]: "",

  [taxpayersName.name]: "",
  [taxpayersId.name]: "",
  [unit.name]: "",
  [auditOpinion.name]: "",

  [bctc.name]: false,
  [htldl.name]: false,
};

export default initialValues;
